import { prop } from 'ramda'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useAsset } from '../_load/AssetLoader'
import FieldValuesPresenter from '../../../../containers/fieldValues/FieldValuesPresenter'
import LabelValue from '../../../../packages/kiti/components/presentation/LabelValue'
import PlacePresenter from '../../../../containers/places/PlacePresenter'
import { useSessionPermission } from '@btime/react-session'

const AssetDetails = () => {
  const asset = useAsset()
  const canSeeConfidentialFields = useSessionPermission('seeConfidentialFields')
  const place = prop('place')(asset)
  const type = prop('type')(asset)
  const fieldValues = prop('fieldValues')(asset)

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      {place && (
        <Col width="50%">
          <LabelValue label="Local/Pessoa">
            <PlacePresenter place={place} weight="500" />
          </LabelValue>
        </Col>
      )}

      {type?.name && (
        <Col width="50%">
          <LabelValue label="Tipo" value={type?.name} />
        </Col>
      )}

      <Col width="100%">
        <FieldValuesPresenter fieldValues={fieldValues} hideConfidential={!canSeeConfidentialFields} />
      </Col>
    </Grid>
  )
}

export default AssetDetails
